// ABOUTME: Translated labels for job detail types, keyed by the DetailType enum value.
// ABOUTME: Decouples the drill-down identity (enum value) from the text the user reads.

import { defineMessages, MessageDescriptor } from 'react-intl';

import { DetailType } from '../types';

// The DetailType values themselves stay untouched: they are the drill-down key and they feed
// the BaseTable column ids, which the data-table can persist per id.
const messages = defineMessages({
    [DetailType.CREATED]: { id: 'job.counter.created', defaultMessage: 'Created' },
    [DetailType.CREATED_MODIFIED]: {
        id: 'job.counter.createdModified',
        defaultMessage: 'Created and modified',
    },
    [DetailType.PRICING_CHANGES]: {
        id: 'job.counter.pricingChanges',
        defaultMessage: 'Price changes',
    },
    [DetailType.NON_RELEVANT_CHANGES]: {
        id: 'job.counter.nonRelevantChanges',
        defaultMessage: 'Non-relevant changes',
    },
    [DetailType.NON_MODIFIED]: { id: 'job.counter.nonModified', defaultMessage: 'Not modified' },
    [DetailType.DISABLED]: { id: 'job.counter.disabled', defaultMessage: 'Deactivated' },
    [DetailType.ALIGNED_MODELS]: {
        id: 'job.counter.alignedModels',
        defaultMessage: 'Aligned models',
    },
    [DetailType.ALIGNED_GLS]: { id: 'job.counter.alignedGls', defaultMessage: 'Aligned GLs' },
    [DetailType.UPDATED_GLS]: { id: 'job.counter.updatedGls', defaultMessage: 'Updated GLs' },
    [DetailType.UPDATED_MODELS]: {
        id: 'job.counter.updatedModels',
        defaultMessage: 'Updated models',
    },
    [DetailType.NEW_FAMILIES_ADDED]: {
        id: 'job.counter.newFamiliesAdded',
        defaultMessage: 'New families added',
    },
    [DetailType.REALIGNED_FAMILIES]: {
        id: 'job.counter.realignedFamilies',
        defaultMessage: 'Realigned families',
    },
    [DetailType.CREATED_FAMILIES]: {
        id: 'job.counter.createdFamilies',
        defaultMessage: 'Created families',
    },
    [DetailType.CREATED_MODELS]: {
        id: 'job.counter.createdModels',
        defaultMessage: 'Created models',
    },
    [DetailType.REMOVED_SCHEDE]: {
        id: 'job.counter.removedSchede',
        defaultMessage: 'Removed schede',
    },
    [DetailType.REPUBLISHED_SCHEDE]: {
        id: 'job.counter.republishedSchede',
        defaultMessage: 'Republished schede',
    },
    [DetailType.BLOCKED_PRICE_UPDATE]: {
        id: 'job.counter.blockedPriceUpdate',
        defaultMessage: 'Blocked price updates',
    },
    [DetailType.BLOCKED_NOT_CHARGED_UPDATE]: {
        id: 'job.counter.blockedNotChargedUpdate',
        defaultMessage: 'Blocked not-charged updates',
    },
    [DetailType.FAILURES]: { id: 'job.counter.failures', defaultMessage: 'Errors' },
    [DetailType.WARNINGS]: { id: 'job.counter.warnings', defaultMessage: 'Warnings' },
});

export const DETAIL_TYPE_LABELS: Partial<Record<DetailType, MessageDescriptor>> = messages;
